module.exports = __webpack_public_path__ + "assets/img/john_paul_dejoria-0545fe17.jpg";